<template>
  <svg
    width="10"
    height="14"
    viewBox="0 0 10 14"
  >
    <path d="M2 4V2C2 0.89543 2.89543 0 4 0C4.36429 0 4.70584 0.0973981 5.00002 0.267574C5.29419 0.0973984 5.63574 0 6.00003 0C7.1046 0 8.00003 0.89543 8.00003 2V4H8.5C9.32843 4 10 4.67157 10 5.5V12C10 13.1046 9.10457 14 8 14H2C0.895431 14 0 13.1046 0 12V5.5C0 4.67157 0.671573 4 1.5 4H2ZM3 2V4H5V2C5 1.44772 4.55228 1 4 1C3.44772 1 3 1.44772 3 2ZM8 13C8.55228 13 9 12.5523 9 12V5.5C9 5.22386 8.77614 5 8.5 5H7V12C7 12.5523 7.44772 13 8 13ZM6 5H1.5C1.22386 5 1 5.22386 1 5.5V12C1 12.5523 1.44772 13 2 13H6.26756C6.09739 12.7058 6 12.3643 6 12V5ZM6 2V4H7.00003V2C7.00003 1.44772 6.55232 1 6.00003 1C5.91378 1 5.83009 1.01092 5.75025 1.03145C5.90939 1.31841 6 1.64862 6 2Z" />
  </svg>
</template>
